import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
}

export const CouponIcon = ({
  width = 24,
  height = 24,
  color = designTokens.colors.text.primary,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M18 20V20.75V20ZM2 8H1.25H2ZM6 4V3.25V4ZM2.31526 9.63574L2.07078 10.3448L2.31526 9.63574ZM2.31523 14.3633L2.55966 15.0723L2.31523 14.3633ZM21.6848 14.3633L21.9292 13.6542L21.6848 14.3633ZM21.6847 9.63574L21.4403 8.92671L21.6847 9.63574ZM18 4V4.75C19.7949 4.75 21.25 6.20507 21.25 8H22H22.75C22.75 5.37665 20.6234 3.25 18 3.25V4ZM22 8H21.25V9.22284H22H22.75V8H22ZM21.6847 9.63574L21.4403 8.92671C20.1666 9.36588 19.25 10.575 19.25 12H20H20.75C20.75 11.2344 21.242 10.5817 21.9292 10.3448L21.6847 9.63574ZM20 12H19.25C19.25 13.4252 20.167 14.6334 21.4403 15.0723L21.6848 14.3633L21.9292 13.6542C21.2418 13.4173 20.75 12.7652 20.75 12H20ZM22 14.7762H21.25V16H22H22.75V14.7762H22ZM22 16H21.25C21.25 17.7949 19.7949 19.25 18 19.25V20V20.75C20.6234 20.75 22.75 18.6234 22.75 16H22ZM18 20V19.25H6V20V20.75H18V20ZM6 20V19.25C4.20507 19.25 2.75 17.7949 2.75 16H2H1.25C1.25 18.6234 3.37665 20.75 6 20.75V20ZM2 16H2.75V14.7762H2H1.25V16H2ZM2.31523 14.3633L2.55966 15.0723C3.83303 14.6334 4.75 13.4252 4.75 12H4H3.25C3.25 12.7652 2.75821 13.4173 2.07081 13.6542L2.31523 14.3633ZM4 12H4.75C4.75 10.575 3.83342 9.36588 2.55974 8.92671L2.31526 9.63574L2.07078 10.3448C2.75798 10.5817 3.25 11.2344 3.25 12H4ZM2 9.22284H2.75V8H2H1.25V9.22284H2ZM2 8H2.75C2.75 6.20507 4.20507 4.75 6 4.75V4V3.25C3.37665 3.25 1.25 5.37665 1.25 8H2ZM6 4V4.75H18V4V3.25H6V4ZM2.31526 9.63574L2.55974 8.92671C2.62652 8.94973 2.75 9.03774 2.75 9.22284H2H1.25C1.25 9.78842 1.64429 10.1977 2.07078 10.3448L2.31526 9.63574ZM2 14.7762H2.75C2.75 14.9612 2.62654 15.0493 2.55966 15.0723L2.31523 14.3633L2.07081 13.6542C1.64424 13.8013 1.25 14.2106 1.25 14.7762H2ZM21.6848 14.3633L21.4403 15.0723C21.3735 15.0493 21.25 14.9612 21.25 14.7762H22H22.75C22.75 14.2106 22.3558 13.8013 21.9292 13.6542L21.6848 14.3633ZM22 9.22284H21.25C21.25 9.03774 21.3735 8.94973 21.4403 8.92671L21.6847 9.63574L21.9292 10.3448C22.3557 10.1977 22.75 9.78842 22.75 9.22284H22Z"
      fill={color}
    />
    <circle
      cx="9.79883"
      cy="9.79811"
      r="0.791538"
      transform="rotate(45 9.79883 9.79811)"
      fill={color}
    />
    <circle
      cx="14.2031"
      cy="14.2014"
      r="0.791538"
      transform="rotate(45 14.2031 14.2014)"
      fill={color}
    />
    <path
      d="M9.76262 14.2384L14.2402 9.76074"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

CouponIcon.displayName = 'CouponIcon'
